import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../common/others/SharedDispatcher";
import { MagnificPopup } from "../../../common/dynamic-imports/MagnificPopup";

export default Backbone.View.extend({

    selectors: {

        'container': '.js-qas-popin-container',
        'content': '.js-qas-popin-content',
        'button': '.js-select-address',
        'backButton': '.js-qas-back',

        'buttonDataAddress': 'addressline1',
        'buttonDataFloor': 'addressline2',
        'buttonDataAddressComplementary': 'addressline3',
        'buttonDataZipCode': 'zipcode',
        'buttonDataCity': 'city',
    },

    events: {},

    templateContent: '',

    selected: undefined,

    _preload: function () {

        var $element = $(this.selectors.container).clone();

        $element.removeClass('hide');

        this.templateContent = $element.html();
    },

    _set: function(element) {

        var address = $(element).data(this.selectors.buttonDataAddress);
        var floor = $(element).data(this.selectors.buttonDataFloor);
        var addrComplementary = $(element).data(this.selectors.buttonDataAddressComplementary);
        var zipCode = $(element).data(this.selectors.buttonDataZipCode);
        var city = $(element).data(this.selectors.buttonDataCity);

        this.selected = {

            'Address': address,
            'Floor': floor,
            'AddressComplimentary': addrComplementary,
            'ZipCode': zipCode,
            'City': city
        };
    },

    initialize: function (options) {
        this.magnificPopup = new MagnificPopup();
        this._preload();
    },

    open: function () {

        if (!this.templateContent || this.templateContent.trim() === '') {
            return;
        }

        var self = this;

        this.magnificPopup.open({

            items: {
                src: self.templateContent,
                showCloseBtn: true
            },
            callbacks: {

                open: () => {

                    $(self.selectors.content).on('click', self.selectors.button, function () {

                        self._set($(this));

                      SharedDispatcher.trigger('QAS:selected', self.selected);
                    });

                    $(self.selectors.content).on('click', self.selectors.backButton, function () {

                        self.close();
                    });
                },

                close: () => {

                }
            }
        });
    },

    close: function () {
      this.magnificPopup.close();
    }

});
